<template>
  <nav class="navbar navbar-expand-sm navbar-light bg-light">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <div class="navbar-toggler-inside">
        <span class="active-item-on-collapsed-menu">
          <span v-if="$router.currentRoute.path == '/services'">MOJE SLUŽBY</span>
          <!-- <span v-else-if="$router.currentRoute.path == '/agreements'">MOJE SMLOUVA</span> -->
          <span v-else-if="$router.currentRoute.path == '/devices'">MOJE KONCOVÁ ZAŘÍZENÍ</span>
          <span v-else-if="$router.currentRoute.path == '/account'">MŮJ ÚČET</span>
          <span v-else-if="$router.currentRoute.path == '/findocs'">MOJE FAKTURY</span>
          <span v-else-if="$router.currentRoute.path == '/personal'">OSOBNÍ ÚDAJE</span>
          <span v-else-if="$router.currentRoute.path == '/referral'">DOPORUČ &amp; ZÍSKEJ</span>
        </span>
        <span class="navbar-toggler-icon"></span>
      </div>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item"><router-link class="nav-link" to="/services">MOJE SLUŽBY</router-link></li>
        <!-- <li class="nav-item"><router-link class="nav-link" to="/agreements">MOJE SMLOUVA</router-link></li> -->
        <li class="nav-item"><router-link class="nav-link" to="/devices">MOJE KONCOVÁ ZAŘÍZENÍ</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/account">MŮJ ÚČET<span v-if="nedoplatek" id="nedoplatek" class="badge badge-pill badge-danger">-{{nedoplatek}} Kč</span></router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/findocs">MOJE FAKTURY</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/personal">OSOBNÍ ÚDAJE</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/referral">DOPORUČ &amp; ZÍSKEJ</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'rd-samoobsluha-navbar',
  computed: {
    nedoplatek () {
      if (this.$store.state.cashTotals.overdue_amount > 0) {
        return parseFloat(this.$store.state.cashTotals.overdue_amount).toFixed(2)
      }
      return false
    }
  }
}
</script>
<style scoped>
nav {
  font-size: 1rem;
  padding: 0;
  padding-top: 8px;
}
.router-link-exact-active, .active-item-on-collapsed-menu {
  color: #EB8108 !important;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  padding-bottom: 11px;
  border-bottom-width: 5px;
  border-color: #EB8108;
  border-style: solid;
}
.active-item-on-collapsed-menu {
  padding-bottom: 6px;
  font-size: 80%;
}
.navbar-toggler {
  width: 100%;
}
.navbar-toggler-inside {
  /* width: 60%; */
  display: flex;
  justify-content: space-between;
}

span#nedoplatek {
  margin-left: 0.5em;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?19593eda